export enum KeyboardEventKey {
    Backspace = "Backspace",
    Delete = "Delete",
    Escape = "Escape",
    ArrowDown = "ArrowDown",
    ArrowUp = "ArrowUp",
    Enter = "Enter",
}
